import Axios from 'axios';

export const getAxiosInstance = (options) => {
  const axiosOptions = Object.assign(
    {
      contentType: 'application/json;charset=utf-8',
      // TODO add XSRF data here
    },
    options,
  );

  return Axios.create(axiosOptions);
};
